<template>
    <section class="banner" :style="{ 'background-image': 'url(' + imagem + ')' }">
        <p class="title">Certificado<br>Samba Maníacos 2019</p>
    </section>
</template>
<script>
import ImgSobre from '@/assets/img/home/home.jpg'

export default {
    name: 'Videos',
    data () {
        return {
            imagem: ImgSobre
        }
    },
    mounted () {
    }
}
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/mixin"

    .banner
        height: 80vh
        background-position: center
        background-size: cover
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column

        .title
            text-align: center
            line-height: 1.2
        p
            color: white
            font-weight: 800
            font-size: 60px
            margin-bottom: 0
            text-shadow: 0px 2px 15px #000000a6
            @include device(mobile)
                &
                    font-size: 40px
                    text-align: center
                    line-height: 1.2
        a
            color: white
            padding: 0 50px
            margin-bottom: -50px
            &:hover,
            &:active
                color: white
</style>
